import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/client';
import { leerUltimaActividad } from '../utils/inactividad';

// Sesiones en vivo (oct 2026): mientras la pestaña esta visible avisa al backend
// cada minuto que la pagina sigue abierta, cuanto hace que la persona no la toca
// y en que pantalla esta. Lo usa Admin > Monitoreo. Con la pestaña oculta no
// manda nada, asi que la sesion pasa a "sin señal" a los 3 minutos.

const CADA_MS = 60 * 1000;

function enviarPing(ruta) {
  if (document.visibilityState !== 'visible') return;
  const ultima = leerUltimaActividad();
  const inactivoSeg = ultima ? Math.max(0, Math.round((Date.now() - ultima) / 1000)) : null;
  api.post('/monitoreo/ping', { ruta, inactivoSeg }).catch(() => {
    // Solo monitoreo: si falla no se avisa nada al usuario
  });
}

export default function usePingSesion(activo) {
  const { pathname } = useLocation();
  const rutaRef = useRef(pathname);
  rutaRef.current = pathname;

  // Latido cada minuto y al volver a la pestaña
  useEffect(() => {
    if (!activo) return undefined;
    const ping = () => enviarPing(rutaRef.current);
    const intervalo = setInterval(ping, CADA_MS);
    document.addEventListener('visibilitychange', ping);
    return () => {
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', ping);
    };
  }, [activo]);

  // Al entrar y al cambiar de pantalla se informa enseguida
  useEffect(() => {
    if (activo) enviarPing(pathname);
  }, [activo, pathname]);
}
